import { html } from 'lit';
import type { TefComs4cs4p } from '@src/components/TefComs4cs4p.js';

// This is just for testing
export const forTesting = function render(this: TefComs4cs4p) : ReturnType<typeof html> {
  return html`<p>${this.loadedResourcesCount}</p>`;
};
